module.exports = __webpack_public_path__ + "img/PWMLFF_support.5f841912.png";